import {
  createFileRoute,
  useNavigate,
} from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"

import { ServiceForm } from "@/components/changelog/service-form"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export const Route = createFileRoute(
  "/_authenticated/$orgSlug/changelog/services/new",
)({
  loader: ({ params }) => ({
    title: "Novo serviço",
    path: `/${params.orgSlug}/changelog/services/new`,
  }),
  component: NewServicePage,
})

function NewServicePage() {
  const { orgSlug } = Route.useParams()
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            navigate({
              to: "/$orgSlug/changelog",
              params: { orgSlug },
            })
          }
        >
          <ArrowLeft className="mr-1 h-4 w-4" />
          Voltar
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Novo serviço</CardTitle>
          <CardDescription>
            Crie um novo serviço para publicar atualizações
            no changelog.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ServiceForm
            organizationSlug={orgSlug}
            onSuccess={() =>
              navigate({
                to: "/$orgSlug/changelog",
                params: { orgSlug },
              })
            }
          />
        </CardContent>
      </Card>
    </div>
  )
}
